<template>
  <div class="right-0 flex flex-col md:flex-row justify-between items-stretch md:items-end mb-4 gap-3">
    <div class="flex flex-1 items-end gap-3">
      <fwb-input
        v-model="searchQuery"
        placeholder="Buscar por ID, título, ubicación"
        class="w-full bg-white border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0"
        @input="onSearch"
      >
        <template #prefix>
          <div>
            <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
          </div>
        </template>
      </fwb-input>
    </div>

    <TypePropertyFilterComponent
      ref="typePropertyRef"
      v-model="filterTypeProperty"
      :options="props.typeProperty"
      width-class="w-full md:w-fit"
      @open="closeOthers('typeProperty')"
    />

    <TypeMovementFilterComponent
      ref="typeMovementRef"
      v-model="filterTypeMovement"
      :options="props.movements"
      width-class="w-full md:w-fit"
      @open="closeOthers('typeMovement')"
    />

    <StateFilterComponent
      ref="stateRef"
      v-model="filterState"
      :options="props.states"
      width-class="w-full md:w-fit"
      @open="closeOthers('state')"
    />

    <PriceRangeFilter
      ref="priceRangeRef"
      :currency="filterCurrency"
      :min-price="filterMinPrice"
      :max-price="filterMaxPrice"
      dropdown-align="right"
      button-class="cursor-default gap-2 justify-between inline-flex items-center bg-white border-[#DEE2E6] text-gray-500 rounded-md focus:ring-tuin-100 focus:border-tuin-100 bg-brand box-border border focus:ring-1 shadow-xs leading-5 rounded-base text-sm py-2.5 pr-3 pl-3 w-full md:w-auto focus:outline-none"
      @update:currency="v => filterCurrency = v"
      @update:minPrice="v => filterMinPrice = v"
      @update:maxPrice="v => filterMaxPrice = v"
      @change="onChangeFilter"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { FwbInput} from 'flowbite-vue';
import PriceRangeFilter from '@/components/common/PriceRangeFilter.vue';
import TypePropertyFilterComponent from '@/components/exchange/components/TypePropertyFilterComponent.vue';
import TypeMovementFilterComponent from '@/components/exchange/components/TypeMovementFilterComponent.vue';
import StateFilterComponent from '@/components/exchange/components/StateFilterComponent.vue';

const props = defineProps({
  typeProperty:  { type: Array,           default: () => [] },
  movements:     { type: Array,           default: () => [] },
  states:        { type: Array,           default: () => [] },
});

const emit = defineEmits(['search', 'change-filter', 'add-property']);

const searchQuery         = ref(null);
const filterTypeProperty  = ref([]);
const filterTypeMovement  = ref('');
const filterState          = ref('');

const typePropertyRef     = ref(null);
const typeMovementRef     = ref(null);
const stateRef            = ref(null);
const priceRangeRef       = ref(null);

watch(filterTypeProperty, () => onChangeFilter(), { deep: true });
watch(filterTypeMovement, () => onChangeFilter(), { deep: true });
watch(filterState,        () => onChangeFilter(), { deep: true });

const filterCurrency      = ref('');
const filterMinPrice      = ref('');
const filterMaxPrice      = ref('');

function closeOthers(except) {
  if (except !== 'typeProperty') typePropertyRef.value?.close();
  if (except !== 'typeMovement') typeMovementRef.value?.close();
  if (except !== 'state')        stateRef.value?.close();
  if (except !== 'price')        priceRangeRef.value?.close();
}

function onSearch() {
  emit('search', searchQuery.value);
}

function onChangeFilter() {
  typePropertyRef.value?.close();
  typeMovementRef.value?.close();
  stateRef.value?.close();
  emit('change-filter', {
    filterTypeOperation: filterTypeMovement.value,
    filterTypeProperty:  filterTypeProperty.value,
    filterState:         filterState.value,
    filterCurrency:      filterCurrency.value,
    filterMinPrice:      filterMinPrice.value,
    filterMaxPrice:      filterMaxPrice.value,
  });
}
</script>